import React, { Fragment } from 'react';
import { withRouter } from "react-router-dom";
import styled from 'styled-components';

// import backgroundImage from '../../assets/img/background-image.png';

import { media } from '../../utilities/style-utilities';

const MainWrapper = styled.main`
  display: flex;
  position: relative;
  flex: 0 0 auto;
  justify-content: center;
`;

const Background = styled.div`
  position: absolute;
  left:0;
  top:0;
  height: 14rem;
  width: 100%;
  /* ${props => props.gradientColor ? props.gradientColor : 'rgba(7, 30, 75, 0.7)'} */
  background: linear-gradient(${props => props.gradientColor ? props.gradientColor : 'rgba(7, 30, 75, 0.7)'}, ${props => props.gradientColor ? props.gradientColor : 'rgba(7, 30, 75, 0.7)'}), url(${props => props.backgroundImage ? props.backgroundImage : ''});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;

  ${ media.desktop`
    display: none;
  `}
`;

const BackgroundBlock = styled.div`
  position: absolute;
  top: 14rem;
  bottom: 0;
  left: 0;
  right: 0;
  /* background-color: rgb(0, 135, 208); */
  background-color: ${props => props.backgroundColor ? props.backgroundColor : 'rgb(0, 135, 208)'};

  ${ media.desktop`
    top: 0;
  `}
`;

const Main = (props) => {
  return (
    <MainWrapper>

        { props.children }

        
        { props.landing ? 
          null
        :
          <Fragment>
            <Background backgroundImage={props.site.backgroundImage} gradientColor={props.site.backgroundImageColorGradient}/>
            <BackgroundBlock backgroundColor={props.site.backgroundColor}/>
          </Fragment>
        }
        
    </MainWrapper>
  );
}


export default withRouter(Main);


// WEBPACK FOOTER //
// ./src/components/Main/Main.js